import { css } from 'styled-components'

/**
 * Reusable tier color styles
 */
export const tierGradientBackgroundStyle = css`
  &.tier-bronze {
    background: ${props => props.theme.palette.product.loyalty.bronze.gradientPrimaryBackground};
  }

  &.tier-silver {
    background: ${props => props.theme.palette.product.loyalty.silver.gradientPrimaryBackground};
  }

  &.tier-gold {
    background: ${props => props.theme.palette.product.loyalty.gold.gradientPrimaryBackground};
  }

  &.tier-platinum {
    background: ${props => props.theme.palette.product.loyalty.platinum.gradientPrimaryBackground};
  }
`

/**
 * Tier darkBackground color styles (for icon badges, accent backgrounds)
 */
export const tierDarkBackgroundStyle = css`
  &.tier-bronze {
    background: ${props => props.theme.palette.product.loyalty.bronze.darkBackground};
  }

  &.tier-silver {
    background: ${props => props.theme.palette.product.loyalty.silver.darkBackground};
  }

  &.tier-gold {
    background: ${props => props.theme.palette.product.loyalty.gold.darkBackground};
  }

  &.tier-platinum {
    background: ${props => props.theme.palette.product.loyalty.platinum.darkBackground};
  }
`

/**
 * Tier lightContrast color styles (for text on gradient backgrounds)
 */
export const tierLightContrastColorStyle = css`
  &.tier-bronze {
    color: ${props => props.theme.palette.product.loyalty.bronze.lightContrast};
  }

  &.tier-silver {
    color: ${props => props.theme.palette.product.loyalty.silver.lightContrast};
  }

  &.tier-gold {
    color: ${props => props.theme.palette.product.loyalty.gold.lightContrast};
  }

  &.tier-platinum {
    color: ${props => props.theme.palette.product.loyalty.platinum.lightContrast};
  }
`

/**
 * Tier normalContrast background color styles (for dividers, accents)
 */
export const tierNormalContrastBackgroundStyle = css`
  &.tier-bronze {
    background-color: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
  }

  &.tier-silver {
    background-color: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
  }

  &.tier-gold {
    background-color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
  }

  &.tier-platinum {
    background-color: ${props => props.theme.palette.product.loyalty.platinum.normalContrast};
  }
`

/**
 * Tier normalContrast color styles (for text)
 */
export const tierNormalContrastColorStyle = css`
  &.tier-bronze {
    color: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
  }

  &.tier-silver {
    color: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
  }

  &.tier-gold {
    color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
  }

  &.tier-platinum {
    color: ${props => props.theme.palette.product.loyalty.platinum.normalContrast};
  }
`
